<template>
  <div class="blog-post-card group cursor-pointer bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col h-full">
    
    <div class="relative overflow-hidden h-48 bg-gray-100">
      <img 
        :src="post.getPhoto()" 
        :alt="post.title"
        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
      
      <div class="absolute bottom-3 left-3 flex flex-wrap gap-2">
        <span 
          v-for="(tag, index) in post.getTags()" 
          :key="index"
          class="bg-purple-suit-forced text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider"
        >
          {{ tag }}
        </span>
      </div>
    </div>

    <div class="p-5 flex flex-col flex-grow">
      <div class="flex items-center justify-between mb-3 text-xs text-gray-500">
        <span class="font-medium flex items-center gap-1 text-carrot">
          <i class="pi pi-user"></i> {{ post.author_name }}
        </span>
        <span class="flex items-center gap-1">
          <i class="pi pi-calendar"></i> {{ post.getUpdatedDate() }}
        </span>
      </div>

      <h3 class="text-xl font-bold text-secondary mb-3 group-hover:text-purple-suit-forced transition-colors line-clamp-2">
        {{ post.title }}
      </h3>

      <p class="text-gray-600 text-sm line-clamp-3 mb-4 flex-grow" v-html="post.getShortenedText()"></p>

      <div class="pt-4 border-t border-gray-100 flex justify-between items-center">
        <Button 
          :label="translate('read more', 'ucfirst')" 
          icon="pi pi-arrow-right" 
          iconPos="right" 
          class="p-button-text p-button-sm p-0 font-bold"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import BlogPost from "@/api/models/BlogPost";
import { translate } from '@/composables/translate';

const props = defineProps({
  post: {
    type: BlogPost,
    required: true
  }
});
const post = computed(() => props.post);
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>